import React, {useState} from 'react';
import styles from './index.module.less';
import {Button, Card, Classes, Elevation, FormGroup, InputGroup, Intent} from "@blueprintjs/core";
import classes from 'classnames';
import axios from 'axios';
import constant from "../../store/constant";
import {useDispatch} from "react-redux";
import { useHistory } from 'react-router-dom';
const AccountLogin = () => {
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [errorText, setErrorText] = useState('');
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  const handleLogin = () => {
    if (!userName || !password) {
      setErrorText('用户名和密码必填');
      return;
    }
    setLoading(true);
    axios.post('/api/pytip/login', {
      name: userName,
      pwd: password
    }).then(response => {
      if (response.data.code !== 0) {
        setLoading(false);
        setErrorText(response.msg);
        return;
      }
      axios.get('/api/pytip/user/profile').then(response => {
        setLoading(false);
        const { code, data } = response.data;
        const { user_info: userInfo = {} } = data;
        if (code !== 0 || userInfo.user_id === null) {
          setErrorText('用户信息获取失败');
          return;
        }
        dispatch({
          type: constant.userInfo.SET_USER_INFO,
          payload: {
            avatar: userInfo.avatar,
            userId: userInfo.user_id,
            userName: userInfo.user_name
          }
        });
        history.replace('/')
      });
    });
  };
  return (
    <div className={styles.login}>
      <Card className={styles.main} elevation={Elevation.FOUR}>
        <h3 className={classes(Classes.HEADING, styles.header)}>登录系统，开始学习</h3>
        <div className={styles.body}>
          <FormGroup helperText={errorText}>
            <InputGroup value={userName} onChange={(e) => setUserName(e.target.value)} className={styles.input} large type='text' leftIcon='user' placeholder='请输入用户名' />
            <InputGroup value={password} onChange={(e) => setPassword(e.target.value)} className={styles.input} large type='password' leftIcon='lock' placeholder='请输入密码' />
          </FormGroup>
        </div>
        <div className={styles.footer}>
          <Button loading={loading} onClick={handleLogin} type='button' intent={Intent.SUCCESS} large>确认登录</Button>
          {/*<Button onClick={() => window.open('http://www.pythontip.com/user/register', '_self')} className={styles.register} type='button' intent={Intent.DANGER} large>注册新账号</Button>*/}
          <Button onClick={() => history.push('/login')} className={styles.register} type='button' intent={Intent.DANGER} large>微信扫一扫注册或登录</Button>
        </div>
      </Card>
    </div>
  );
};

export default AccountLogin;
